import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            minHeight: '100vh',
            background: '#0f1419',
            color: '#e8eaed',
            fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            boxSizing: 'border-box',
          }}
        >
          <div style={{ maxWidth: 420, textAlign: 'center' }}>
            <h1 style={{ fontSize: '1.35rem', margin: '0 0 12px' }}>Something went wrong</h1>
            <p style={{ color: '#9aa0a6', lineHeight: 1.5, margin: '0 0 20px' }}>
              Transport Team could not load. Try a hard refresh (Ctrl+Shift+R). If this keeps happening,
              contact support.
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              style={{
                padding: '12px 18px',
                borderRadius: 10,
                border: 'none',
                background: 'linear-gradient(180deg, #0d7377, #0a5c5f)',
                color: '#fff',
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Reload
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
